import { render } from "./CreateExam.vue?vue&type=template&id=32fad0b6&scoped=true"
import script from "./CreateExam.vue?vue&type=script&lang=js"
export * from "./CreateExam.vue?vue&type=script&lang=js"

import "./CreateExam.vue?vue&type=style&index=0&id=32fad0b6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fad0b6"]])

export default __exports__